import { snakeCase, camelCase } from 'change-case';
import * as R from 'ramda';

import mapKeys from './mapKeys';
import { isOpaqueValueKey } from './opaqueKeys';

const objectKeysTo = (
  transformStrategy: TransformStrategy,
) => {
  const converter: ObjectKeysConverter = R.ifElse(
    R.is(Array),
    R.map(value => converter(value)),
    R.when(
      R.is(Object),
      R.pipe(
        mapKeys(transformStrategy),
        // Was R.map(converter), which recursed into every value. Values behind
        // an opaque key are user data whose keys must survive verbatim —
        // see utils/opaqueKeys.ts. The key itself is still converted above.
        R.mapObjIndexed((value, key) =>
          (isOpaqueValueKey(key) ? value : converter(value))),
      ),
    ),
  );

  return converter;
};

type TransformStrategy = (s: string) => string;

type ObjectKeysConverter = (param: any) => any;

export const objectKeysToSnakeCase = objectKeysTo(
  snakeCase,
);
export const objectKeysToCamelCase = objectKeysTo(
  camelCase,
);
